"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferentialsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var ReferentialsApi = /** @class */ (function (_super) {
    __extends(ReferentialsApi, _super);
    function ReferentialsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all CIM-10 by search parameter
     */
    ReferentialsApi.prototype.getCIM10Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['items'] != null) {
                            queryParameters['items'] = requestParameters['items'];
                        }
                        if (requestParameters['equal'] != null) {
                            queryParameters['equal'] = requestParameters['equal'];
                        }
                        if (requestParameters['like'] != null) {
                            queryParameters['like'] = requestParameters['like'];
                        }
                        if (requestParameters['mode'] != null) {
                            queryParameters['mode'] = requestParameters['mode'];
                        }
                        if (requestParameters['orderByDesc'] != null) {
                            queryParameters['order_by_desc'] = requestParameters['orderByDesc'];
                        }
                        if (requestParameters['orderByAsc'] != null) {
                            queryParameters['order_by_asc'] = requestParameters['orderByAsc'];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/v1/referential/cim10",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(index_1.CIM10OutputFromJSON); })];
                }
            });
        });
    };
    /**
     * Get all CIM-10 by search parameter
     */
    ReferentialsApi.prototype.getCIM10 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCIM10Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list of marital status
     */
    ReferentialsApi.prototype.getMaritalStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['items'] != null) {
                            queryParameters['items'] = requestParameters['items'];
                        }
                        if (requestParameters['equal'] != null) {
                            queryParameters['equal'] = requestParameters['equal'];
                        }
                        if (requestParameters['like'] != null) {
                            queryParameters['like'] = requestParameters['like'];
                        }
                        if (requestParameters['mode'] != null) {
                            queryParameters['mode'] = requestParameters['mode'];
                        }
                        if (requestParameters['orderByDesc'] != null) {
                            queryParameters['order_by_desc'] = requestParameters['orderByDesc'];
                        }
                        if (requestParameters['orderByAsc'] != null) {
                            queryParameters['order_by_asc'] = requestParameters['orderByAsc'];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/v1/referential/marital-status",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.MaritalStatusOutputFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get list of marital status
     */
    ReferentialsApi.prototype.getMaritalStatus = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMaritalStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list of specialities
     */
    ReferentialsApi.prototype.getSpecialitiesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['items'] != null) {
                            queryParameters['items'] = requestParameters['items'];
                        }
                        if (requestParameters['equal'] != null) {
                            queryParameters['equal'] = requestParameters['equal'];
                        }
                        if (requestParameters['like'] != null) {
                            queryParameters['like'] = requestParameters['like'];
                        }
                        if (requestParameters['mode'] != null) {
                            queryParameters['mode'] = requestParameters['mode'];
                        }
                        if (requestParameters['orderByDesc'] != null) {
                            queryParameters['order_by_desc'] = requestParameters['orderByDesc'];
                        }
                        if (requestParameters['orderByAsc'] != null) {
                            queryParameters['order_by_asc'] = requestParameters['orderByAsc'];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/v1/referential/specialities",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SpecialityOutputFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get list of specialities
     */
    ReferentialsApi.prototype.getSpecialities = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSpecialitiesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ReferentialsApi;
}(runtime.BaseAPI));
exports.ReferentialsApi = ReferentialsApi;
